import IconLoading from 'components/Common/Icons/IconLoading';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import isSearchLoading from 'store/search/selector/isSearchLoading';
import fetchResultsForPreviousPageOperation from 'store/search/operation/fetchResultsForPreviousPageOperation';
import getPreviousPageNr from 'store/search/selector/getPreviousPageNr';
import getOffset from 'store/search/selector/getOffset';
import styles from './LoadMoreItemsBefore.module.scss';

const LoadMoreItemsBefore = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(isSearchLoading);
  const previousPageNr = useSelector(getPreviousPageNr);
  const resultsOffset = useSelector(getOffset);

  const [fetchingPage, setFetchingPage] = useState(false);

  const loadMore = (e: any) => {
    e.preventDefault();
    setFetchingPage(true);
    dispatch(fetchResultsForPreviousPageOperation());
  };

  const { t } = useTranslation();

  useEffect(() => {
    if (isLoading && fetchingPage) {
      return () => {
        setFetchingPage(false);
      };
    }
    return () => {};
  }, [isLoading, fetchingPage]);

  if (resultsOffset === 0) {
    return null;
  }

  return (
    <div className={styles.loadMoreItemsBefore}>
      <div className={styles.loadMoreButton}>
        <OpButton onClick={loadMore}>
          {fetchingPage && <IconLoading className={styles.loadingIcon} />}
          {!isLoading && t('txt_previous_page')}
        </OpButton>
      </div>
    </div>
  );
};

export default LoadMoreItemsBefore;
